/**
 * 서버 응답 → 화면 모델.
 * 목록 응답(WebhookSummary)에는 configuration.headers 가 없으므로 headers 는 빈 배열이 된다.
 * @param {object} dto - Webhook | WebhookSummary
 */
export const normalizeWebhook = (dto) => {
    if (!dto) return null;
    return {
        ...dto,
        endpoint: dto.configuration?.endpoint ?? "",
        headers: Object.entries(dto.configuration?.headers ?? {}).map(([key, value], index) => ({
            id: index,
            key,
            value,
        })),
    };
};

/**
 * 화면 모델의 헤더 배열 → 서버 전송용 객체.
 * 키가 빈 행은 제외한다(입력 중간 상태의 빈 행이 그대로 전송되지 않도록).
 * @param {Array<{ key: string, value: string }>} rows
 */
export const toHeadersObject = (rows = []) =>
    rows.reduce((acc, { key, value }) => {
        if (!key) return acc;
        return { ...acc, [key]: value ?? "" };
    }, {});
